import RouteBase from '@/router/routes/RouteBase.js';

class RoutesMyWallets {
  subFolderPath = '/myWallets';
  isPublic = false;

  WalletsHome = new RouteBase({
    name: 'wallets-home',
    path: '',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Home',
    isPublic: this.isPublic,
    meta: {
      icon: 'wallet',
      startupConfig: {
        setCustomerDetail: true,
      },
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
        title: 'Puan Takip',
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Cüzdanlarım',
        },
      ],
    },
  });
  ConvertScore = new RouteBase({
    name: 'wallets-convert',
    path: 'convert',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'ConvertScore',
    isPublic: this.isPublic,
    meta: {
      icon: 'wallet',
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
        title: 'Puan Takip',
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Cüzdanlarım',
          link: '/secure/my-wallets',
        },
        {
          name: 'Puan Takip',
        },
      ],
    },
  });
  WalletsDetail = new RouteBase({
    name: 'wallets-detail',
    path: 'detail',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Detail',
    isPublic: this.isPublic,
    meta: {
      icon: 'wallet',
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
        title: 'Puan Takip',
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Cüzdanlarım',
          link: '/secure/my-wallets',
        },
        {
          name: 'Puan Takip',
        },
      ],
    },
  });
}

export default new RoutesMyWallets();
